export const constants = {
    NO_DATA: 'Nincs adat',
    NO_DATA_OR_BEING_CALCULATED: 'nincs adat vagy számolás alatt',
};
